import React from "react";

import svg_error from "assets/svg/error.svg";
import svg_success from "assets/svg/success.svg";

export default function StatusError({ status }) {
  return (
    <div className="text-center pt-[30px] flex flex-col items-center">
      <img
        src={(status.type === "success" && svg_success) || (status.type === "error" && svg_error)}
        className="h-[300px]"
      />
      <h1>{status.title}</h1>
      <div>{status.body}</div>
      {status.cta && (
        <div>
          <a href={status.cta.link} className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-[25px]">
            {status.cta.text}
          </a>
        </div>
      )}
    </div>
  );
}
